"use client";

import { useState } from "react";
import { handleError } from "@/lib/apiUtils";
import { useSearchParams } from "next/navigation";
import { emailSignIn } from "@/lib/signInUtils";
import { CookieName } from "@/types/nextCookie";
import posthog from "posthog-js";

const useLandingPageInvite = () => {
  const [loading, setLoading] = useState(false);
  const searchParams = useSearchParams();

  const joinWaitlist = async (emailAddress: string) => {
    try {
      setLoading(true);

      // Extract and clean all query parameters from the URL
      const sourceParams: Record<string, string> = {};
      searchParams.forEach((value, key) => {
        // Clean up keys that might have encoding issues
        const cleanKey = key.replace(/^\?/, ""); // Remove leading ? if present
        sourceParams[cleanKey] = value;
      });

      // Store source parameters in a cookie so they can be accessed in the createUser event
      if (Object.keys(sourceParams).length > 0) {
        document.cookie = `${CookieName.SOURCE_PARAMS}=${JSON.stringify(sourceParams)}; path=/; max-age=3600; SameSite=Lax`;
      }

      // Build callback URL for the ads flow
      const callbackUrl = new URL("/onboarding", window.location.origin);
      callbackUrl.searchParams.set("webview", "true");

      // Use NextAuth email provider instead of custom API
      emailSignIn(emailAddress, callbackUrl.toString());
      posthog.identify(emailAddress);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  return {
    loading,
    joinWaitlist,
  };
};

export default useLandingPageInvite;
